module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline hidden-xs-only"
  }, [_vm._v(_vm._s(_vm.titulo))]), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-xs-only"
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mr-1",
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.limparSelecao()
      }
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), (this.selected.length == 1) ? _c('v-btn', {
    staticClass: "ml-1 mr-1",
    attrs: {
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (this.selected.length > 0) ? _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "slot": "activator",
      "dark": "",
      "ripple": "",
      "color": "primary",
      "icon": "icon"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "selected-key": "id",
      "select-all": "",
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_c('v-checkbox', {
          attrs: {
            "color": "primary",
            "hide-details": ""
          },
          model: {
            value: (props.selected),
            callback: function($$v) {
              _vm.$set(props, "selected", $$v)
            },
            expression: "props.selected"
          }
        })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', _vm._l((props.item.permissoes), function(value) {
          return _c('div', {
            key: value.id,
            staticClass: "accent permissao"
          }, [_vm._v("\n            " + _vm._s(value.authority) + "\n          ")])
        }))]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.confirm.title))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.confirm.contentHtml))]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.cancel))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.excluir()
      }
    }
  }, [_vm._v(_vm._s(_vm.confirm.ok))])], 1)], 1)], 1), _vm._v(" "), _c('v-fab-transition', [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "to": "/admin/menu/new",
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": ""
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75e35db3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 380
// module chunks = 1